import { cloneDeep } from 'lodash';
import { isObject } from 'util';

import * as SearchformNhActions from '../actions/searchform-nh';
import * as TabsActions from '../../../xena-tabs/state-management/actions/tabs';

import { InitialSearchformNhState, SearchformNhModel } from '../../shared/models/searchform/searchform-nh.model';
import { InitialState as InitialTabState } from '../../../xena-tabs/state-management/reducers/tabs';
import { InitialQueryState, QueryModel } from '../../shared/models/query/query.model';


export interface StateObj {
	form: SearchformNhModel;
	state: QueryModel;
	tab: number;
	selected: boolean;
}

export type State = Array<StateObj>;

export const InitialState: State = [{
	form: { ...cloneDeep(InitialSearchformNhState) },
	state: { ...cloneDeep(InitialQueryState), type: 'NH' },
	tab: InitialTabState[0].id,
	selected: InitialTabState[0].selected
}];


export function reducer(state: State = InitialState, action: SearchformNhActions.All | TabsActions.All): State {
	switch (action.type) {
		case SearchformNhActions.UPDATE_SEARCHFORM_NH:
			return state.map(s => {
				if (s.selected) {
					s.form = { ...s.form, ...action.payload };
				}

				return s;
			});

		case SearchformNhActions.RESET_SEARCHFORM_NH:
			return state.map(s => {
				if (s.selected) {
					s.form = { ...cloneDeep(InitialSearchformNhState) };
				}

				return s;
			});

		case SearchformNhActions.SUBMIT_SEARCHFORM_NH:
			return state.map(s => {
				if (s.selected) {
					s.form = action.payload;
				}

				return s;
			});

		case SearchformNhActions.ADD_SEARCHFORM_NH_STATE:
			return state.map(s => {
				if (s.selected) {
					s.state = action.payload;
				}

				return s;
			});

		case SearchformNhActions.INIT_SEARCHFORM_NH_TABS:
			return action.payload.map((tab, index) => ({
				form: isObject(state[index]) && isObject(state[index].form) ? state[index].form : { ...cloneDeep(InitialSearchformNhState) },
				state: isObject(state[index]) && isObject(state[index].state) ? state[index].state : { ...cloneDeep(InitialQueryState), type: 'NH' },
				tab: tab.id,
				selected: tab.selected
			}));

		case TabsActions.ADD_TAB:
			return state.concat({
				form: { ...cloneDeep(InitialSearchformNhState) },
				state: { ...cloneDeep(InitialQueryState), type: 'NH' },
				tab: action.payload.id,
				selected: false
			});

		case TabsActions.SELECT_TAB:
			return state.map(stateObj => ({ ...stateObj, selected: stateObj.tab === action.payload.id }));

		case TabsActions.REMOVE_TAB:
			if (state.length === 1) {
				return state;
			}

			const tabToRemove = state.find(stateObj => stateObj.tab === action.payload.id);
			const newState = state.filter(stateObj => stateObj.tab !== action.payload.id);

			if (tabToRemove.selected) {
				newState[0].selected = true;
			}

			return newState;

		default:
			return state;
	}
}

export const GetSelected = (s: State): SearchformNhModel => s.find(st => st.selected).form;
export const GetSearchformNhState = (s: State): QueryModel => s.find(st => st.selected).state;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/searchform-nh.ts